const configurator = require('core-js/configurator');

configurator({
  useNative: ['Promise'], // polyfills will be used only if natives completely unavailable
});
